module.exports = __webpack_public_path__ + "img/muito-feliz.d08396c4.png";